import { fetch } from "@/helpers/fetch"; //引用fetch.js

/** 获取舆情日报
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * openid，
 * reportType 1日报，2周报，3月报
 */
export function getReportList(data) {
    return fetch({
        url: `/api/wechat/getAiReportList`,
        method: 'get',
        params: data
    })
}
/** 下载报告（流式下载）
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * reportId 报告ID
 * version 报告版本号
 * reportType 报告类型
 */
export function downloadReport(data) {
    return fetch({
        url: `/api/wechat/file/download`,
        method: 'get',
        params: data,
        responseType: 'blob' // 关键：设置响应类型为 blob，用于接收二进制流
    })
}

/** 获取 WPS 预览 URL
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * reportId 报告ID
 * version 报告版本号
 * reportType 报告类型
 */
export function getWpsPreviewUrl(data) {
    return fetch({
        url: `/api/wechat/file/wps/preview`,
        method: 'get',
        params: data
    })
}


export function getReportDetail(data) {
    return fetch({
        url: `/api/wechat/detail`,
        method: 'get',
        params: data
    })
}
